import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { getBackgroundColorStyle } from '@/utils/background';

import { getHeightStyle, getWidthStyle } from '../../utils/sizing';

import * as styles from '../Navbar.css';
import type { NavbarMenuListElementProps } from '../Navbar.type';
import { NAVBAR_MENU_LIST_DEFAULTS } from './NavbarMenuList.constants';
import { NavbarMenuListContextProvider } from './NavbarMenuListProvider';

export function NavbarMenuList(props: NavbarMenuListElementProps) {
  const { element, children, className, attributes } = props;
  const {
    justify = NAVBAR_MENU_LIST_DEFAULTS.justify,
    background,
    padding,
    margin,
    customAttributes,
    gap,
    height,
    contentWidth,
    lineDividerStyle,
    lineDividerWidth,
    lineDividerColor,
    lineDividerHeight,
    lineDividerStyleX,
    lineDividerWidthX,
    lineDividerColorX,
  } = element.attrs || {};

  return (
    <NavbarMenuListContextProvider>
      {/* biome-ignore lint/a11y/useValidAriaRole: TODO: Add aria-role */}
      <div
        {...props}
        role="none"
        {...attributes}
        {...customAttributes}
        className={classNames(styles.navbarMenuList, className, customAttributes?.className)}
        data-justify={justify ?? NAVBAR_MENU_LIST_DEFAULTS.justify}
        style={
          {
            '--width': NAVBAR_MENU_LIST_DEFAULTS.width,
            '--max-width': NAVBAR_MENU_LIST_DEFAULTS.width,
            '--justify': justify ?? NAVBAR_MENU_LIST_DEFAULTS.justify,
            '--margin': margin ?? NAVBAR_MENU_LIST_DEFAULTS.margin,
            ...getBackgroundColorStyle(background ?? NAVBAR_MENU_LIST_DEFAULTS.background),
            '--height': height ? getHeightStyle(height).height : NAVBAR_MENU_LIST_DEFAULTS.height,
            borderBottom:
              lineDividerStyleX !== 'none' ? `${lineDividerWidthX} ${lineDividerStyleX} ${lineDividerColorX}` : 'none',
            '--padding': padding ?? NAVBAR_MENU_LIST_DEFAULTS.padding,
          } as CSSProperties
        }
      >
        <div
          className={styles.navbarMenuListContent}
          data-line-divider={lineDividerStyle && lineDividerStyle !== 'none'}
          style={
            {
              '--content-width': contentWidth
                ? getWidthStyle(contentWidth, undefined).width
                : NAVBAR_MENU_LIST_DEFAULTS.contentWidth,
              '--max-content-width': contentWidth
                ? getWidthStyle(contentWidth, undefined).maxWidth
                : NAVBAR_MENU_LIST_DEFAULTS.contentWidth,
              '--gap': gap ?? NAVBAR_MENU_LIST_DEFAULTS.gap,
              '--line-divider-style': lineDividerStyle ?? 'none',
              '--line-divider-width': lineDividerWidth ?? '0.5px',
              '--line-divider-color': lineDividerColor ?? 'black',
              '--line-divider-height': lineDividerHeight ?? '18px',
            } as CSSProperties
          }
        >
          {children}
        </div>
      </div>
    </NavbarMenuListContextProvider>
  );
}
